module.exports = __webpack_public_path__ + "public/Icons/playAudio.svg?a68bb47d";